import React, { FunctionComponent, memo, MouseEvent } from 'react';
import { Link as MaterialLink } from '@material-ui/core';
import Translation from '../../../../../../../../gqlCommon/components/translation/Translation';
import summaryStyles from '../../../summarySection/SummaryStyles';

export interface ISelectedOptionActionLinkProps {
  onClick: (e: MouseEvent<HTMLAnchorElement>) => void;
}

const ChangeSelectedOptionLink: FunctionComponent<ISelectedOptionActionLinkProps> = memo(({ onClick }) => {
  const styles = summaryStyles();
  return (
    <MaterialLink
      onClick={onClick}
      variant={'helpingText'}
      color={'secondary'}
      underline={'always'}
      data-test={'colour:button:change'}
      className={styles.changeAction}
    >
      <Translation id={'trans__configurator__customise_page_summary_section__change_selection_link'} />
    </MaterialLink>
  );
});

export default ChangeSelectedOptionLink;
